import { render, staticRenderFns } from "./RatingBlock.vue?vue&type=template&id=c6ad1238&scoped=true&"
import script from "./RatingBlock.vue?vue&type=script&lang=js&"
export * from "./RatingBlock.vue?vue&type=script&lang=js&"
import style0 from "./RatingBlock.vue?vue&type=style&index=0&id=c6ad1238&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6ad1238",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
